import React from 'react';
export var ModalDialog = React.createClass({

    render() {
        return (

            <div id="new-facility" className="modal fade in" role="dialog" style={{ display: 'block' }} >
                <div className="modal-content-text create-facility-modal ">
                    <div className="modal-box">
                        <div className="modal-dialog">
                            <div className="modal-content text-center">
                                <span className="icon-success"></span>
                                <p>New clinic has been added successfully.</p>
                                <p className="admin-facility">Want to add admin to clinic?</p>
                                <button className="gray-button margin-right-10" onClick={this.props.addadmin}>Yes</button>
                                <button className="white-button" onClick={this.props.doitlater}  >Will do later</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/modal_dialog.jsx
 **/